<template>
    <InformeCard id="devoluciones" name="devoluciones" collapsable="true" title="Devoluciones">
        <div class="table-responsive">
            <table class="table table-hover text-nowrap">
                <thead>
                    <tr>
                        <th>TIPO DE PRECIO</th>
                        <th>MÉTODO DE PAGO</th>
                        <th>PRECIO</th>
                        <th>DEVOLUCIONES</th>
                        <th>TOTAL</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(venta, index) in informe">
                        <tr :key="index">
                            <td>{{ venta.description }}</td>
                            <td>{{ venta.metodo_pago | formatear_metodo_pago_entrada }}</td>
                            <td>{{ venta.price | formatear_precio }}</td>
                            <td>{{ venta.total }}</td>
                            <td>{{ venta.price * venta.total | formatear_precio }}</td>
                        </tr>
                    </template>
                    <tr>
                        <td colspan="3">TOTAL</td>
                        <td>{{ getTotalVendidas() }}</td>
                        <td>{{ getRecaudacionTotal() | formatear_precio }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </InformeCard>
</template>

<script>
    import InformeCard from "../InformeCard";

    export default {
        props: ['event_id', 'informe'],
        methods: {
            getTotalVendidas() {
                var total = 0;
                for (var i = 0; i < this.informe.length; i++) {
                    total = total + this.informe[i].total;
                }

                return total;
            },
            getRecaudacionTotal() {
                var total = 0;
                for (var i = 0; i < this.informe.length; i++) {
                    var rec = this.informe[i].total * this.informe[i].price
                    total = total + rec;
                }

                return total;
            }
        },
        components: {
            InformeCard
        }
    }
</script>